module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/c30d6a0e73cf38ad6ea7f5e4fe0428a3.png";